import React from "react";
import { Link } from "react-router-dom";
import { usePublicSettings } from "@/lib/settings";

const HERO = "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function About() {
  const { settings } = usePublicSettings();
  const about = settings?.about || {};

  return (
    <div className="pb-16">
      <section className="relative h-[50vh] flex items-end overflow-hidden">
        <img src={HERO} alt="ABE" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 hero-fade" />
        <div className="relative mx-auto max-w-4xl w-full px-4 sm:px-6 pb-10">
          <span className="section-eyebrow">Absolutely Business Entertainment</span>
          <h1 className="font-display text-5xl sm:text-6xl uppercase text-white leading-[0.9] mt-2">{about.headline || "About ABE"}</h1>
        </div>
      </section>

      <div className="mx-auto max-w-3xl px-4 sm:px-6 mt-10">
        <p className="text-zinc-300 leading-relaxed whitespace-pre-line text-lg">{about.body}</p>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4">
          {["Nightlife", "Concerts", "Day Parties", "Experiences"].map((x) => (
            <div key={x} className="rounded-xl border border-[#27272A] bg-[#141417] p-5 text-center">
              <p className="font-oswald text-sm tracking-widest text-[#D4AF37] uppercase">{x}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-2xl border border-[#27272A] bg-gradient-to-br from-[#141417] to-[#09090B] p-8 text-center">
          <h2 className="font-display text-3xl uppercase text-white">Come Experience ABE</h2>
          <Link to="/events" className="btn-gold inline-block mt-4 rounded-md px-8 py-3.5 font-oswald text-sm tracking-widest">UPCOMING EVENTS</Link>
        </div>
      </div>
    </div>
  );
}
